/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartUpdateCustomerNotesVariables = Types.Exact<{
  cartUuid: Types.Scalars['String']
  customerNotes: Types.Scalars['String']
}>

export type CartUpdateCustomerNotes = {
  __typename: 'Root'
  cartUpdateCustomerNotes: {
    __typename: 'CartUpdateCustomerNotesPayload'
    cart: {
      __typename: 'Cart'
      id: number | null
      customerNotes: string
    } | null
    errors: Array<{
      __typename: 'UserError'
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CartUpdateCustomerNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CartUpdateCustomerNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cartUuid' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customerNotes' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cartUpdateCustomerNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartUuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cartUuid' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customerNotes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customerNotes' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerNotes' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CartUpdateCustomerNotesMutationFn = Apollo.MutationFunction<
  CartUpdateCustomerNotes,
  CartUpdateCustomerNotesVariables
>

/**
 * __useCartUpdateCustomerNotes__
 *
 * To run a mutation, you first call `useCartUpdateCustomerNotes` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartUpdateCustomerNotes` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartUpdateCustomerNotes, { data, loading, error }] = useCartUpdateCustomerNotes({
 *   variables: {
 *      cartUuid: // value for 'cartUuid'
 *      customerNotes: // value for 'customerNotes'
 *   },
 * });
 */
export function useCartUpdateCustomerNotes(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CartUpdateCustomerNotes,
    CartUpdateCustomerNotesVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CartUpdateCustomerNotes,
    CartUpdateCustomerNotesVariables
  >(CartUpdateCustomerNotesDocument, options)
}
export type CartUpdateCustomerNotesHookResult = ReturnType<
  typeof useCartUpdateCustomerNotes
>
export type CartUpdateCustomerNotesMutationResult =
  Apollo.MutationResult<CartUpdateCustomerNotes>
export type CartUpdateCustomerNotesMutationOptions = Apollo.BaseMutationOptions<
  CartUpdateCustomerNotes,
  CartUpdateCustomerNotesVariables
>
